// Glicosimetro LinkSun-BGM (modelo HS08, fabricante FDSCONN).
//
// Protocolo decifrado na Etapa 0 e conferido contra o visor do aparelho:
// o quadro `55 0c 03 18 0a 01 0a 06 00 d5 00 6e` bateu com "213 mg/dL, 10-01 10:06".
// Documentacao completa em etapa0-ble/ACHADOS.md.
//
// GATT: servico 0x1000, canal de dados 0x1002 (notify). Basta assinar — o
// aparelho transmite sozinho ao medir, sem comando de partida.

export const LINKSUN_SERVICO = 0x1000;
export const LINKSUN_CARACTERISTICA = 0x1002;

export type QuadroLinkSun =
  | { tipo: 'contagem'; restante: number; checksumOk: boolean }
  | {
      tipo: 'resultado';
      valor: number;
      unidade: 'mg/dL' | 'mmol/L';
      /** Data/hora que o RELOGIO DO APARELHO informou — costuma estar errado. */
      medidoEmAparelho: Date;
      checksumOk: boolean;
    }
  | { tipo: 'desconhecido'; comando: number; checksumOk: boolean };

/**
 * Checksum = (soma de todos os bytes anteriores + 2) & 0xFF.
 * O `+ 2` e constante empirica, validada nos 7 quadros capturados na Etapa 0.
 */
export function checksumLinkSun(bytes: Uint8Array): number {
  let soma = 2;
  for (let i = 0; i < bytes.length - 1; i++) soma += bytes[i]!;
  return soma & 0xff;
}

export function decodificarLinkSun(dados: Uint8Array): QuadroLinkSun | null {
  if (dados.length < 4 || dados[0] !== 0x55) return null;

  const comando = dados[2]!;
  const checksumOk = checksumLinkSun(dados) === dados[dados.length - 1];

  if (comando === 0x02) {
    return { tipo: 'contagem', restante: dados[4]!, checksumOk };
  }

  if (comando === 0x03 && dados.length >= 12) {
    const ano = 2000 + dados[3]!;
    const medidoEmAparelho = new Date(ano, dados[4]! - 1, dados[5]!, dados[6]!, dados[7]!);
    const valor = (dados[8]! << 8) | dados[9]!; // uint16 big-endian
    return {
      tipo: 'resultado',
      valor,
      unidade: dados[10] === 0 ? 'mg/dL' : 'mmol/L',
      medidoEmAparelho,
      checksumOk,
    };
  }

  return { tipo: 'desconhecido', comando, checksumOk };
}
